/**
 * Session-only unlock for the "Export scan log" control in Settings
 * (2026-09-18 owner ask). The control used to be admin-only, so a trainer
 * reporting a live-scan bug had no way to send the log. Now a Pro account can
 * reveal it by tapping the version number seven times, and the reveal lives
 * here, in memory: it survives leaving Settings to run a scan and coming back,
 * and it is gone when the app is closed, because the raw telemetry is not a
 * control ordinary trainers should keep finding.
 */
let unlocked = false;

export function isScanLogExportUnlocked(): boolean {
  return unlocked;
}

export function unlockScanLogExport(): void {
  unlocked = true;
}

/** Test seam. */
export function __resetScanLogExportUnlockForTests(): void {
  unlocked = false;
}

/**
 * Handles that see "Export scan log" permanently, no gesture and no tier
 * (2026-09-22 owner ask: the owner's own Android test account, so the
 * scanner errors on the Galaxy can be exported on the spot every time).
 * Lower-case; compared case-insensitively.
 */
export const SCAN_LOG_EXPORT_HANDLES: ReadonlyArray<string> = ["nexusdexapp", "aracapri"] as const;
/** Account ids with the same standing (2026-09-22: the Galaxy's account, id 23). */
export const SCAN_LOG_EXPORT_ACCOUNT_IDS: ReadonlyArray<number> = [23] as const;

export function isScanLogExportAccount(
  username: string | null | undefined,
  accountId?: number | null,
): boolean {
  if (accountId != null && SCAN_LOG_EXPORT_ACCOUNT_IDS.includes(accountId)) return true;
  if (!username) return false;
  const lowered = username.trim().replace(/^@/, "").toLowerCase();
  return SCAN_LOG_EXPORT_HANDLES.includes(lowered);
}
